var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#32CCCC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5487 28.1701H23.4513C23.1729 29.8246 21.7337 31.0851 20 31.0851C18.2664 31.0851 16.8271 29.8246 16.5487 28.1701ZM20 8.33789C24.8325 8.33789 28.75 12.2554 28.75 17.0879V21.7528L30.4047 25.4396C30.4688 25.5823 30.5019 25.737 30.5019 25.8934C30.5019 26.5055 30.0057 27.0018 29.3936 27.0018H10.6109C10.4548 27.0018 10.3005 26.9688 10.158 26.905C9.59934 26.6549 9.34919 25.9992 9.5993 25.4406L11.25 21.7532L11.2501 17.0728L11.2553 16.7813C11.4175 12.0787 15.2819 8.33789 20 8.33789ZM32.8333 15.625C33.3166 15.625 33.7083 16.0168 33.7083 16.5C33.7083 16.943 33.3792 17.3091 32.9521 17.367L32.8333 17.375H30.5C30.0168 17.375 29.625 16.9833 29.625 16.5C29.625 16.057 29.9542 15.6909 30.3813 15.633L30.5 15.625H32.8333ZM9.50001 15.625C9.98325 15.625 10.375 16.0168 10.375 16.5C10.375 16.943 10.0458 17.3091 9.61874 17.367L9.50001 17.375H7.16667C6.68342 17.375 6.29167 16.9833 6.29167 16.5C6.29167 16.057 6.62085 15.6909 7.04794 15.633L7.16667 15.625H9.50001ZM32.3667 8.97501C32.6303 9.32647 32.5895 9.81168 32.2894 10.1148L32.1917 10.2L29.8583 11.95C29.4717 12.24 28.9233 12.1616 28.6333 11.775C28.3697 11.4236 28.4105 10.9383 28.7106 10.6352L28.8083 10.55L31.1417 8.80001C31.5283 8.51006 32.0767 8.58841 32.3667 8.97501ZM8.85834 8.80001L11.1917 10.55C11.5783 10.84 11.6566 11.3884 11.3667 11.775C11.0767 12.1616 10.5283 12.24 10.1417 11.95L7.80834 10.2C7.42174 9.91006 7.34339 9.36161 7.63334 8.97501C7.92329 8.58841 8.47174 8.51006 8.85834 8.80001Z",
    fill: "#32CCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.0f685e716ab841b814f99cfe8496133f.svg";
export { ForwardRef as ReactComponent };